import "core-js/modules/es.array.concat.js";
import React from 'react';
import { BASIC } from 'styles/spacingPresets';
import Card from 'components/Card';
import Box from 'components/Box';
import Flex from 'components/Flex';
import Text from 'components/Text';
import PageTitle from 'components/PageTitle';
import OverflowTooltip from 'components/OverflowTooltip';
import ScrollableNav from 'components/ScrollableNav';
import useUniqueId from 'hooks/useUniqueId';
import { CloseButton } from './CloseButton';
import { hasReactChildren } from 'utils/ui';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function EditorPageHeader(_ref) {
  var wrapperRef = _ref.wrapperRef,
    title = _ref.title,
    providedTitleId = _ref.titleId,
    titleSuffix = _ref.titleSuffix,
    documentTitle = _ref.documentTitle,
    subtitle = _ref.subtitle,
    preTitleContent = _ref.preTitleContent,
    navigationLabel = _ref.navigationLabel,
    children = _ref.children,
    navMenu = _ref.navMenu,
    cardVariant = _ref.cardVariant,
    onClose = _ref.onClose;
  var uniqueId = useUniqueId();
  var titleId = providedTitleId || uniqueId;
  var suffixedTitle = titleSuffix ? "".concat(title, " ").concat(titleSuffix) : title;
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/_jsxs(Card, {
    ref: wrapperRef,
    as: "header",
    variant: cardVariant,
    position: "relative",
    pl: BASIC.LARGE,
    pr: "m",
    pt: BASIC.SMALL,
    pb: hasChildren ? undefined : BASIC.SMALL,
    breakpoints: BASIC.BREAKPOINTS,
    overflow: "visible",
    "aria-labelledby": titleId,
    children: [/*#__PURE__*/_jsxs(Flex, {
      pb: hasChildren ? 'xxs' : undefined,
      align: "top",
      children: [/*#__PURE__*/_jsxs(Box, {
        grow: true,
        shrink: true,
        children: [Boolean(preTitleContent) && /*#__PURE__*/_jsx(Box, {
          mb: "xs",
          children: preTitleContent
        }), /*#__PURE__*/_jsx(OverflowTooltip, {
          content: suffixedTitle,
          placement: "bottom-start",
          children: /*#__PURE__*/_jsxs(PageTitle, {
            id: titleId,
            size: "large",
            text: documentTitle || title,
            overflow: "ellipsis",
            children: [title, Boolean(titleSuffix) && /*#__PURE__*/_jsxs(_Fragment, {
              children: [' ', /*#__PURE__*/_jsx(Text, {
                size: "m",
                bold: false,
                ml: "xxs",
                children: titleSuffix
              })]
            })]
          })
        }), Boolean(subtitle) && /*#__PURE__*/_jsx(Box, {
          mt: "xs",
          children: subtitle
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        mt: "-xxs",
        mr: "-s",
        children: [navMenu, onClose && /*#__PURE__*/_jsx(CloseButton, {
          onClick: onClose
        })]
      })]
    }), /*#__PURE__*/_jsx(ScrollableNav, {
      navigationLabel: navigationLabel,
      children: children
    })]
  });
}
export default EditorPageHeader;
export { default as StickyEditorPageHeaderWrapper } from './StickyEditorPageHeaderWrapper';
export { default as SimpleCreationPageHeader } from './SimpleCreationPageHeader';
export { CloseButton };